import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchCenter, createCenter, updateCenter } from './actions';
import CenterSettingsForm, { selector as centerSettingsFormSelector } from './SettingsForm';
import authUtils from '../../auth/utils';
import { loadTerritoriesByFranchisee } from '../territories/actions';
import { withTranslation } from 'react-i18next';
import CenterPayments from '../payments';
import { paymentOwners } from '../payments/methods/common';
import PriceList from './PriceList';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import Holidays from '../centerHolidays';
import TermsDropdownList from '../terms/DropdownList';
import ZoomConfiguration from '../zoom/ConfigurationForm';
import queryString from 'query-string';
import { Panel } from 'react-bootstrap';
import { faMoneyBill1 } from '@fortawesome/free-regular-svg-icons';
import { faVideo } from '@fortawesome/free-solid-svg-icons';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleCenterSettingsSubmit = this.handleCenterSettingsSubmit.bind(this);
		this.state = {
			termId: null,
			prices: [],
			defaultYearLessonCount: undefined,
			yearLessonCount: updateCenter
		};
	}

	componentDidMount() {
		const { match, fetchCenter, franchisee } = this.props;
		const centerId = match.params.centerId;

		this.loadTerritories(franchisee.id);

		if (centerId) {
			fetchCenter(centerId);
		}
	}

	componentWillReceiveProps(nextProps) {
		const currentCenter = this.props.center;
		const nextCenter = nextProps.center;

		if (currentCenter && nextCenter && currentCenter.prices.length !== nextCenter.prices.length) //center from list has not loaded prices
			this.handlePriceTermChange(this.state.termId, nextCenter);
	}

	loadTerritories(franchiseeId) {
		const { loadTerritoriesByFranchisee } = this.props;
		loadTerritoriesByFranchisee(franchiseeId);
	}

	handleCenterSettingsSubmit(values) {
		const { center, createCenter, updateCenter, history } = this.props;

		if (center) {
			updateCenter(center.id, values);
		} else {
			createCenter(values, history);
		}
	}

	handlePriceTermChange(termId, center) {
		if (center) {
			const prices = Object.values(center.prices);
			let pricesByTerm = prices.filter((price) => price.term.id == termId);

			const selectedTerm = this.props.terms[termId];
			const defaultYearLessonCount = (selectedTerm && selectedTerm.schoolYear ? selectedTerm.schoolYear.lessonCount : undefined);

			this.setState({
				termId: termId,
				prices: pricesByTerm,
				defaultYearLessonCount: defaultYearLessonCount,
				yearLessonCount: center.numberOfLessonsInSchoolYear || defaultYearLessonCount
			});
		}
	}

	renderPricesPanel() {
		const { center, franchisor, paymentTypes, t } = this.props;
		let lessonCount = this.state.yearLessonCount ? t('Price_YearLessons', { yearLessonCount: this.state.yearLessonCount }) : '';
		return (
			<CollapsablePanel icon={faMoneyBill1} title={t('Center_GradeAndPrices')} collapsed>
				<TermsDropdownList defaultSelection='active' value={this.state.termId} onChange={(termId) => this.handlePriceTermChange(termId, center)} emptyLabel={t('Center_ChooseTerm')} centerId={center.id} />
				<PriceList data={this.state.prices} lessonCount={lessonCount} paymentTypes={paymentTypes} enableTermPrice={franchisor.enableTermPrice} enableTrials={franchisor.enableTrials} />
			</CollapsablePanel>
		);
	}

	renderZoomPanel() {
		const { franchisor, franchisee, center, t } = this.props;
		return (
			<CollapsablePanel icon={faVideo} title={t('Center_ZoomIntegration')} collapsed>
				<ZoomConfiguration franchisor={franchisor} connected={center.zoomConnected} centerId={center.id} franchiseeId={franchisee.id} />
			</CollapsablePanel>
		);
	}

	render() {
		const {
			center, franchisor, isReadonly, territoriesList, franchisee,
			workWithKindergarten, offerIndividualConsultations, offerWorkshops,
			defaultTimeZone, centerFormValues, t, location
		} = this.props;
		const territoryArray = Object.values(territoriesList);
		let territoriesByFranchisee = territoryArray.filter((territory) => territory.franchiseeId === franchisee.id);

		const queryParams = queryString.parse(location.search);
		const selectedPaymentMethodName = queryParams.method;

		return <React.Fragment>
			<Panel>
				<Panel.Heading>{center ? t('Center_Edit') : t('Center_New')}</Panel.Heading>
				<Panel.Body>
					<CenterSettingsForm isReadonly={isReadonly} onSubmit={this.handleCenterSettingsSubmit}
						initialValues={center ? center : { makeUpCanceledOnlyOption: 0, makeupEligibilityOption: 0, offerTermPayment: 1 }}
						territories={territoriesByFranchisee}
						workWithKindergarten={workWithKindergarten}
						offerIndividualConsultations={offerIndividualConsultations}
						offerWorkshops={offerWorkshops}
						defaultTimeZone={defaultTimeZone}
						enableTrials={franchisor.enableTrials}
						enableMakeUps={franchisor.enableMakeUps}
						enableInstalmentPayment={franchisor.enableInstalmentPayment}
						enableAutoEnrolment={franchisor.enableAutoEnrolment}
						defaultYearLessonCount={this.state.defaultYearLessonCount}
						t={t}
						{...centerFormValues} />
				</Panel.Body>
			</Panel>
			{center && this.renderPricesPanel()}
			{center && <Holidays centerId={center.id} />}
			{center && <CenterPayments paymentOwnerId={center.id} paymentOwnerType={paymentOwners.center} franchiseeId={franchisee.id}
				panelTitle={t('Center_PaymentConfiguration')} collapsed selectedPaymentMethodName={selectedPaymentMethodName} />}
			{center && franchisor.zoomClientId && this.renderZoomPanel()}
		</React.Fragment>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const centerId = ownProps.match.params.centerId;

	const {
		entities: { centers, franchiseeAllTerritories, terms },
		lookups: { paymentTypes },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	return {
		center: centers[centerId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Franchisees'),
		territoriesList: franchiseeAllTerritories,
		terms,
		workWithKindergarten: franchisor.workWithKindergarten,
		offerIndividualConsultations: franchisor.offerIndividualConsultations,
		offerWorkshops: franchisor.offerWorkshops,
		defaultTimeZone: ownProps.franchisee.timeZone || franchisor.timeZone,
		centerFormValues: centerSettingsFormSelector(state, 'isTrialLessonPaid', 'allowMakeUpForCanceled', 'allowFutureBooking',
			'automaticNotApproved', 'isIndividualConsultation', 'sendNotApprovedReminder', 'lockClassesForTrialChildren',
			'makeUpCanceledOnlyOption', 'makeupEligibilityOption', 'allowParentCancelLesson', 'sendTrialReminder', 'isAnnualPayment',
			'sendPostTrialNotBookedReminder', 'sendPostTrialNotBookedFranchiseeReminder', 'sendFirstClassOfTermReminder', 'sendWorkshopReminder', 'sendFirstWorkshopFollowUp', 'email'),
		franchisor,
		paymentTypes
	};
};

export default connect(mapStateToProps, {
	fetchCenter,
	createCenter,
	updateCenter,
	loadTerritoriesByFranchisee
})(withTranslation()(Details));